import {useEffect, useState} from 'react'

const LoadingBar = () => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 2000)
    return () => clearTimeout(timer)
  }, [])

  if (!visible) return null

  return (
    <div className='loading-bar-wrapper'>
      <div className='loading-bar' />
    </div>
  )
}

export const LoadingBar2 = ({show}: {show: boolean}) => {
  if (!show) return null

  return (
    <div className='loading-bar-wrapper'>
      <div className='loading-bar' />
    </div>
  )
}

export default LoadingBar
